import Eonnaf1 from '../../../Media/Fasilitas BSD/Eonna/Eonna (1).webp'
import Eonnaf2 from '../../../Media/Fasilitas BSD/Eonna/Eonna (2).webp'
import Eonnaf3 from '../../../Media/Fasilitas BSD/Eonna/Eonna (3).webp'
import Eonnaf4 from '../../../Media/Fasilitas BSD/Eonna/Eonna (4).webp'




const Eonnafimages =[
Eonnaf1,Eonnaf2,Eonnaf3,Eonnaf4
]

export default Eonnafimages;